import React, { ReactElement } from 'react';
import styled, { ColorsTypes } from 'styled-components';

import { Box, Button, Flex, Typography } from 'components';
import { Link } from 'react-router-dom';
import { useProducts } from 'features/products';
import { createUrl } from 'app/utils';
import { contentsTypes } from 'features/contents';
import { useSchool } from 'features/school';

const ContentWrapper = styled(Flex)<{ lineColor: ColorsTypes }>`
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background: ${({ theme, lineColor }) => theme.colors[lineColor]};
    position: absolute;
    top: 0;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      &::before {
        left: 20px;
      }

      ${mediaQueries.tablet} {
        &::before {
          left: 30px;
        }
      }
    `;
  }}
`;

const HatBullet = styled.i<{ bg: ColorsTypes; color: ColorsTypes }>`
  position: absolute;
  display: block;
  background: ${({ theme, bg }) => theme.colors[bg]};
  position: absolute;
  border-radius: 50%;

  &::before {
    content: '';
    display: block;
    border: 1px solid ${({ theme, color }) => theme.colors[color]};
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 20px;
      height: 20px;
      left: -24px;
      top: 1px;

      &::before {
        width: 10px;
        height: 10px;
      }

      ${mediaQueries.tablet} {
        width: 26px;
        height: 26px;
        left: -42px;
        top: -3px;

        &::before {
          width: 13px;
          height: 13px;
        }
      }
    `;
  }}
`;

const ProductsSidebarContinuation = (): ReactElement => {
  const { productsContinuation, availableClasses } = useProducts();
  const { schoolAlias } = useSchool();

  if (!Boolean(productsContinuation && (productsContinuation.currentContentUuid || productsContinuation.nextContentUuid))) return <></>;

  return (
    <ContentWrapper
      alignItems="flex-start"
      pt={{ m: 30, t: 40, d: 40 }}
      pb={{ m: 30, t: 40 }}
      pl={{ m: 35, t: 60 }}
      pr={{ m: 20, t: 40 }}
      flexDirection="column"
      bg={schoolAlias === 'b3' ? 'authLabelColor' : 'dark_350'}
      borderRadius={4}
      lineColor={schoolAlias === 'b3' ? 'white25' : 'gray_600'}
    >
      <Box position="relative">
        <HatBullet bg={schoolAlias === 'b3' ? 'gray_600' : 'dark_350'} color={schoolAlias === 'b3' ? 'white25' : 'gray_600'} />

        <Typography type="type2" color={schoolAlias === 'b3' ? 'white50' : 'white25'} upper>
          Continuar curso
        </Typography>
      </Box>

      <Typography type="type5" color="white" fontWeight="bold" lineHeight="1.25" mt={2}>
        {productsContinuation.currentOrNextContentName}
      </Typography>

      <Box mt={{ m: 20, t: 30 }}>
        {productsContinuation.currentContentUuid ? (
          <Link
            to={createUrl('contentClassDetails', [
              productsContinuation.productSlug,
              availableClasses?.current?.productClassUuid,
              productsContinuation.currentContentProductClassTimelineUuid,
              productsContinuation.currentContentUuid,
              contentsTypes(productsContinuation.currentContentType, productsContinuation.currentExternalDocumentType),
            ])}
          >
            <Button minWidth={200}>Continuar</Button>
          </Link>
        ) : productsContinuation.nextContentUuid ? (
          <Link
            to={createUrl('contentClassDetails', [
              productsContinuation.productSlug,
              availableClasses?.current?.productClassUuid,
              productsContinuation.nextContentProductClassTimelineUuid,
              productsContinuation.nextContentUuid,
              contentsTypes(productsContinuation.nextContentType, productsContinuation.nextExternalDocumentType),
            ])}
          >
            <Button minWidth={200}>{productsContinuation.firstContent ? 'Iniciar' : 'Próxima aula'}</Button>
          </Link>
        ) : (
          <></>
        )}
      </Box>
    </ContentWrapper>
  );
};

export default ProductsSidebarContinuation;
